export default __webpack_public_path__ + "static/media/economic-card.60ec5a51.svg";